import React from 'react';
import styles from './Pricing.module.css';
import Button from '../Shared/Button';

const Pricing = ({ onBuyClick }) => {
  const handleOrder = () => {
    if (onBuyClick) {
      onBuyClick();
    }
  };

  return (
    <section className={styles.pricing} data-section="pricing">
      <div className={styles.container}>
        <h2 className={styles.heading}>
          <span className="gold-text">Начните планирование 2026 года прямо сейчас: ваш будущий успех начинается сегодня</span>
        </h2>
        <div className={styles.priceBox}>
          <div className={styles.price}>$269</div>
          <div className={styles.description}>
            <p>2026 год особенный. Это переходный период, который определит ваше будущее на следующие 60+ лет. Не упустите возможность спланировать его правильно.</p>
            <p>Персональный прогноз по 9 Дворцам - это не просто документ. Это ваш навигатор на весь год, который покажет вам когда действовать, а когда замедлиться, какие дни благоприятны для важных решений, куда не стоит путешествовать в каждый месяц, как привлечь деньги через денежные часы и грабителя богатства, когда бережно относиться к себе, чтобы избежать выгорания.</p>
            <p>Все это - конкретные инструменты и рекомендации, рассчитанные индивидуально по вашей карте рождения. Не общие советы, а персональный план действий на весь 2026 год.</p>
            <p>Инвестиция в $269 окупается многократно, если помогает избежать хотя бы одной серьезной ошибки. А правильное планирование в этот особенный год - это инвестиция в ваше будущее на десятилетия вперед.</p>
          </div>
          <Button onClick={handleOrder} variant="primary" size="large">
            Заказать персональный прогноз за $269
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Pricing;

